import { JSX } from "react";

const NetworkSummaryDescription = (): JSX.Element => {
  return <>
    <p>
      The Summary card offers high-level metrics regarding the overall size and scope of your network.
      This helps contextualize the scale of the data being analyzed and provides context for the metrics displayed throughout the dashboard.
    </p>
    <p>
      Includes the count of:
    </p>
    <ul>
      <li>Unique Providers (NPI)</li>
      <li>Unique Locations (Latitude/Longitude)</li>
      <li>Unique Access Points (NPI, Latitude/Longitude, Specialty Code)</li>
    </ul>
    <p>
      Use the View: Network / Servicing / Prospect toggle to view these counts for different provider groupings within the analysis.
    </p>
  </>;
}

export { NetworkSummaryDescription };